<!-- wrapper -->
<div id="page_container" class="example-container">
  <!---->
  <div class="">
    <div class="breadcrumb_outer">
      <ul class="breadcrumb">
        <li><a>Enertics Inc:</a></li>
        <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
          <a (click)="goToPageLink(item.page_ref)">
            {{ item.page_title }}
          </a>
        </li>
        <li class="active"><a>Trend Analysis</a></li>
      </ul>
      <div class="right"><span>2024-01-02 22:09:48 (EST)</span></div>
    </div>
    <div class="tag_powered_by">
      <span>Powered by: <b>Enertics</b></span>
    </div>
    <div class="Content_outer">
      <div class="custom_tab">
        <div class="tab_right">
          <div class="legendbox legendBoxTop">
            <div style="background-color: #999999"></div>
            <strong>Offline</strong>
            <div style="background-color: #72ff13"></div>
            <strong>Healthy</strong>
            <div style="background-color: #faa700"></div>
            <strong>Unsatisfactory</strong>
            <div style="background-color: #ff2a1b"></div>
            <strong>Unacceptable</strong>
          </div>
          <div class="txt mainStatusWrap">
            <div class="valWrap">
              <span class="sprite_icon wifi_black"></span
              ><span class="seen"><b>Online</b>2024-01-04 02:28:10 (EST)</span>
            </div>
            <div class="statusWrap">
              <span class="seen">
                <img
                  mattooltip="Asset Running"
                  src="assets/images/green.png"
                  class="mat-tooltip-trigger"
                  style="height: 10px; width: 10px"
                />
              </span>

              <span class="seen">
                <div class="dropdown">
                  <button
                    *ngIf="role != 'OEM'"
                    class="btn dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      aria-haspopup="true"
                      src="./assets/settings.png"
                      class="mat-menu-trigger"
                      style="width: 20px; height: 20px; cursor: pointer"
                    />
                  </button>
                  <div class="dropdown-menu client_action">
                    <a class="dropdown-item" href="#">Edit</a>
                    <a class="dropdown-item" href="#">Delete</a>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
        <!-- Tabs Content -->
        <ul ngbNav #ctdTabset="ngbNav" class="tabset1 nav custom_tab nav-v nav-tabs">
          <li [ngbNavItem]="'tab1'" class="">
            <a ngbNavLink>Monitoring</a>
            <ng-template ngbNavContent class="">
              <div class="tab-pane active" id="Monitoring" role="tabpanel">
                <app-asset-static-info />

                <div class="inner_gauge_box row col-md-12">
                  <div class="chart_boxes_outer_V2">
                    <!-- Oil Temperature -->
                    <div class="ch_box b1 col-md-2 position-relative">
                      <div class="heading">Oil Temperature</div>
                      <div class="inner vibrationInner">
                        <!-- <app-skeleton-gauge *ngIf="updateLoader"/> -->
                        <app-spinner *ngIf="updateLoader"/>
                        <app-radial-gauge
                          *ngIf="
                            eTxformerOilTemperatureData &&
                            eTxformerOilTemperatureData.length > 0 && 
                            !updateLoader
                          "
                          matTooltip="Oil Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
                          [matTooltipClass]="'tooltip'"
                          [ngClass]="'custom-css'"
                          [inputData]="eTxformerOilTemperatureData"
                        >
                        </app-radial-gauge>
                      </div>
                      <button
                        *ngIf="role !== 'OEM'"
                        (click)="
                          openExformerGraphSettingsDialog(
                            'OilTemperature',
                            1457
                          )
                        "
                        class="setting_btn_tf  cursor-pointer"
                        role="button"
                      >
                        <img src="./assets/settings.png" class="cursor-pointer rotate-on-hover" />
                      </button>
                    </div>

                    <!-- /Oil Temperature -->
                    <!-- Oil Level -->
                    <div class="ch_box b2 col-md-2 position-relative">
                      <div class="heading">Oil Level</div>
                      <div class="inner vibrationInner">
                        <app-radial-gauge
                          matTooltip="Oil Level Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
                          [matTooltipClass]="'tooltip'"
                          [ngClass]="'custom-css'"
                          [inputData]="eTxformerOilLevelData"
                        >
                        </app-radial-gauge>
                      </div>
                      <button
                        mat-button
                        *ngIf="role !== 'OEM'"
                        (click)="
                          openExformerGraphSettingsDialog('OilLevel', 1457)
                        "
                        class="setting_btn_tf"
                      >
                        <img src="./assets/settings.png" class="cursor-pointer rotate-on-hover" />
                      </button>
                    </div>
                    <!-- /Oil Level -->
                    <!-- Wind Temperature -->
                    <div class="ch_box b3 col-md-4 position-relative">
                      <div class="heading">Winding Temperature</div>
                      <div
                        class="windTemp"
                        style="justify-content: space-around !important"
                      >
                        <div
                          class="inner vibrationInner"
                          *ngFor="
                            let windingTemperature of tXformerWendingTemperatureData
                          "
                        >
                          <ng-container
                            *ngIf="
                              windingtemperatureloading;
                              else windingTemperatureid
                            "
                          >
                            <div class="spinner-container charts-loader">
                              <div
                                class="spinner-border text-primary"
                                role="status"
                              ></div>
                            </div>
                          </ng-container>
                          <ng-template #windingTemperatureid>
                            <app-gauge-chart
                              matTooltip=" Winding Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
                              style="color: orange; color: black"
                              [canvasWidth]="160"
                              [canvasHeight]="140"
                              [matTooltipClass]="'tooltip'"
                              [ngClass]="'custom-css'"
                              [canvasWidth]="canvasWidth"
                              [needleValue]="windingTemperature.needleValue"
                              [needleColor]="
                                windingTemperature.options.needleColor
                              "
                              [centralLabel]="centralLabel"
                              [options]="windingTemperature.options"
                              [name]="windingTemperature.name"
                              [bottomLabel]="windingTemperature.bottomLabel"
                            >
                            </app-gauge-chart>
                          </ng-template>
                        </div>
                      </div>
                      <button
                        mat-button
                        *ngIf="role !== 'OEM'"
                        (click)="
                          openExformerGraphSettingsDialog(
                            'WindingTemperature',
                            1457
                          )
                        "
                        class="setting_btn_tf"
                      >
                        <img src="./assets/settings.png" class="cursor-pointer rotate-on-hover" />
                      </button>
                    </div>
                    <!-- /Wind Temperature -->
                    <!-- ALERT STATUS -->
                    <div class="ch_box b4 col-md-4">
                      <div class="heading">Test</div>
                    </div>
                    <!-- ALERT STATUS -->
                  </div>
                </div>

                <!-- Trends -->
                <div class="section">
                  <div class="sectionHeading">
                    Trends (Actual and Predicted)
                  </div>
                  <div class="summary_boxes_outer">
                    <div class="summaryBox">
                      <ng-container
                        *ngIf="
                          trendsoiltemperatureloading;
                          else trendsoiltemperatureid
                        "
                      >
                        <div
                          class="spinner-container"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>

                      <ng-template #trendsoiltemperatureid>
                        <app-line-chart
                          *ngIf="
                            tXformerTrendsOilTemperatureData &&
                            tXformerTrendsOilTemperatureData.length > 0
                          "
                          [chartContainerId]="'trendsOilTemperature'"
                          [chartData]="tXformerTrendsOilTemperatureData[0]"
                          [chartOptions]="TrendsOilTemperatureLineChartOptions"
                          [chartBgColors]="
                            TrendsOilTemperatureLineChartColors[0]
                          "
                          class="windTemp"
                        >
                        </app-line-chart>
                      </ng-template>
                    </div>

                    <div class="summaryBox">
                      <ng-container
                        *ngIf="trendsoillevelloading; else trendsoillevelid"
                      >
                        <div
                          class="spinner-container"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                      <ng-template #trendsoillevelid>
                        <app-line-chart
                          *ngIf="
                            tXformerTrendsOilLevelData &&
                            tXformerTrendsOilLevelData.length > 0
                          "
                          [chartContainerId]="'trendsOilLevel'"
                          [chartData]="tXformerTrendsOilLevelData[0]"
                          [chartOptions]="TrendsOilLevelLineChartOptions"
                          [chartBgColors]="TrendsOilLevelLineChartColors[0]"
                          class="windTemp"
                        ></app-line-chart>
                      </ng-template>
                    </div>

                    <div class="summaryBox">
                      <ng-container
                        *ngIf="
                          trendswindingtemperatureloading;
                          else trendswindingtemperatureid
                        "
                      >
                        <div
                          class="spinner-container"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                      <ng-template #trendswindingtemperatureid>
                        <app-line-chart
                          *ngIf="
                            tXformerTrendsWindingTemperatureData &&
                            tXformerTrendsWindingTemperatureData.length > 0
                          "
                          [chartContainerId]="'trendsWingingTemperature'"
                          [chartData]="tXformerTrendsWindingTemperatureData[0]"
                          [chartOptions]="
                            TrendsWindingTemperatureLineChartOptions
                          "
                          [chartBgColors]="
                            TrendsWindingTemperatureLineChartColors[0]
                          "
                          class="windTemp"
                        ></app-line-chart>
                      </ng-template>
                    </div>

                    <div class="summaryBox">
                      <ng-container
                        *ngIf="
                          trendspressurereliefvalveloading;
                          else trendspressurereliefvalveid
                        "
                      >
                        <div
                          class="spinner-container"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                      <ng-template #trendspressurereliefvalveid>
                        <app-line-chart
                          *ngIf="
                            tXformerTrendsPressureReliefValveData &&
                            tXformerTrendsPressureReliefValveData.length > 0
                          "
                          [chartContainerId]="'trendsPressureReliefValve'"
                          [chartData]="tXformerTrendsPressureReliefValveData[0]"
                          [chartOptions]="
                            TrendsPressureReliefValveLineChartOptions
                          "
                          [chartBgColors]="
                            TrendsPressureReliefValveLineChartColors[0]
                          "
                          class="windTemp"
                        ></app-line-chart>
                      </ng-template>
                    </div>

                    <div class="summaryBox">
                      <ng-container
                        *ngIf="
                          trendsbuchholzrelayloading;
                          else trendsbuchholzrelayid
                        "
                      >
                        <div
                          class="spinner-container"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                      <ng-template #trendsbuchholzrelayid>
                        <app-line-chart
                          *ngIf="
                            tXformerTrendsBuchholzRelayData &&
                            tXformerTrendsBuchholzRelayData.length > 0
                          "
                          [chartContainerId]="'trendsBuchholzRelay'"
                          [chartData]="tXformerTrendsBuchholzRelayData[0]"
                          [chartOptions]="TrendsBuchholzRelayLineChartOptions"
                          [chartBgColors]="
                            TrendsBuchholzRelayLineChartColors[0]
                          "
                          class="windTemp"
                        ></app-line-chart>
                      </ng-template>
                    </div>

                    <div class="summaryBox">
                      <ng-container
                        *ngIf="trendssurgerelayloading; else trendssurgerelayid"
                      >
                        <div
                          class="spinner-container"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                      <ng-template #trendssurgerelayid>
                        <app-line-chart
                          *ngIf="
                            tXformerTrendsSurgeRelayData &&
                            tXformerTrendsSurgeRelayData.length > 0
                          "
                          [chartContainerId]="'trendsSurgeRelay'"
                          [chartData]="tXformerTrendsSurgeRelayData[0]"
                          [chartOptions]="TrendsSurgeRelayLineChartOptions"
                          [chartBgColors]="TrendsSurgeRelayLineChartColors[0]"
                          class="windTemp"
                        ></app-line-chart>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <!-- /Trends -->
              </div>
            </ng-template>
          </li>
          <!-- <li [ngbNavItem]="'tab2'" class="">
            <a ngbNavLink>Thermals</a>
            <ng-template ngbNavContent class="">
              <div class="tab-pane" id="Thermals" role="tabpanel">
                <app-asset-static-info />

                <div class="inner_gauge_box row col-md-12">
                  <div class="chart_boxes_outer_V2">
                    <div class="ch_box b1 col-md-2 position-relative">
                      <div class="heading">Bushing Temperature</div>
                      <div class="inner vibrationInner">
                        <app-radial-gauge
                          *ngIf="
                            eTxformerOilTemperatureData &&
                            eTxformerOilTemperatureData.length > 0
                          "
                          matTooltip="Oil Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
                          [matTooltipClass]="'tooltip'"
                          [ngClass]="'custom-css'"
                          [inputData]="eTxformerOilTemperatureData"
                        >
                        </app-radial-gauge>
                      </div>
                      <button
                        *ngIf="role !== 'OEM'"
                        (click)="
                          openExformerGraphSettingsDialog(
                            'OilTemperature',
                            1457
                          )
                        "
                        class="setting_btn_tf"
                      >
                        <img src="./assets/settings.png" />
                      </button>
                    </div>

                    <div class="ch_box b2 col-md-2 position-relative">
                      <div class="heading">Connector Temperature</div>
                      <div class="inner vibrationInner">
                        <app-radial-gauge
                          matTooltip="Oil Level Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
                          [matTooltipClass]="'tooltip'"
                          [ngClass]="'custom-css'"
                          [inputData]="eTxformerOilLevelData"
                        >
                        </app-radial-gauge>
                      </div>
                      <button
                        mat-button
                        *ngIf="role !== 'OEM'"
                        (click)="
                          openExformerGraphSettingsDialog('OilLevel', 1457)
                        "
                        class="setting_btn_tf"
                      >
                        <img src="./assets/settings.png" />
                      </button>
                    </div>
                    <div class="ch_box b3 col-md-4 position-relative">
                      <div class="heading">Winding Temperature</div>
                      <div
                        class="windTemp"
                        style="justify-content: space-around !important"
                      >
                        <div
                          class="inner vibrationInner"
                          *ngFor="
                            let windingTemperature of tXformerWendingTemperatureData
                          "
                        >
                          <ng-container
                            *ngIf="
                              windingtemperatureloading;
                              else windingTemperatureid
                            "
                          >
                            <div class="spinner-container charts-loader">
                              <div
                                class="spinner-border text-primary"
                                role="status"
                              ></div>
                            </div>
                          </ng-container>
                          <ng-template #windingTemperatureid>
                            <app-gauge-chart
                              matTooltip=" Winding Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
                              style="color: orange; color: black"
                              [canvasWidth]="160"
                              [canvasHeight]="140"
                              [matTooltipClass]="'tooltip'"
                              [ngClass]="'custom-css'"
                              [canvasWidth]="canvasWidth"
                              [needleValue]="windingTemperature.needleValue"
                              [needleColor]="
                                windingTemperature.options.needleColor
                              "
                              [centralLabel]="centralLabel"
                              [options]="windingTemperature.options"
                              [name]="windingTemperature.name"
                              [bottomLabel]="windingTemperature.bottomLabel"
                            >
                            </app-gauge-chart>
                          </ng-template>
                        </div>
                      </div>
                      <button
                        mat-button
                        *ngIf="role !== 'OEM'"
                        (click)="
                          openExformerGraphSettingsDialog(
                            'WindingTemperature',
                            1457
                          )
                        "
                        class="setting_btn_tf"
                      >
                        <img src="./assets/settings.png" />
                      </button>
                    </div>
                    <div class="ch_box b4 col-md-4">
                      <div class="heading">24 Hours Alert Summary</div>
                    </div>
                  </div>
                </div>

                <div class="section d-flex">
                  <div class="w-75">
                    <div class="sectionHeading">Trends (Actual)</div>
                    <div class="summary_boxes_outer w-100">
                      <div
                        class="summaryBox w-100"
                        [ngStyle]="{ height: '300px' }"
                      ></div>
                    </div>
                  </div>
                  <div class="w-25">
                    <div class="sectionHeading">Thermal Snapshot</div>
                    <div class="summary_boxes_outer">
                      <div
                        class="summaryBox"
                        [ngStyle]="{ height: '300px', width: '100%' }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li> -->
          <li [ngbNavItem]="'tab2'">
            <a ngbNavLink>Tab 3</a>
            <ng-template ngbNavContent class="">
              <div class="tab-pane" id="Tab3" role="tabpanel">
                <app-thermals-tab type="transformer"/>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="ctdTabset"></div>
        <!-- /Tabs Content -->
      </div>
    </div>
  </div>
</div>
